import React from "react";
import ReactTooltip from "react-tooltip";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/sagas/funnelChart";
import styles from "../funnelChart.module.css";

export function LooseConversionsToggle() {
  const dispatch = useDispatch();

  const startFrom = useSelector((state) => state.laser.selectedFilters.startFrom.id);

  const toggleLoose = useSelector((state) => state.laser.selectedFilters.toggleLoose);

  const handleChangeLoose = (event) => {
    dispatch(actionCreators.toggleLoose(event.target.checked));
  };

  return startFrom !== "shows" && startFrom !== "enrollments" ? (
    <>
      <ReactTooltip
        effect="solid"
        id="includeLooseConversions"
        className={styles.toggleTooltip}
      />
      <div className="select-box toggle" style={{ width: 203 }}>
        <span
          data-for="includeLooseConversions"
          data-tip={
            toggleLoose
              ? "A client can be counted as enrolled/converted even if they have not completed the other steps in the funnel; Appointment, Show or First Visit."
              : "A client must have an appointment and show to be counted in Enrollment."
          }
        >
          <p className="offers-title">Include Loose Conversions</p>
          <input
            type="checkbox"
            className="ios8-switch"
            id="loose-toggle"
            checked={toggleLoose}
            onChange={handleChangeLoose}
          />
          <label htmlFor="loose-toggle" />
        </span>
      </div>
    </>
  ) : null;
}
